module.exports = __webpack_public_path__ + "media/dashboard/assets/images/banners/octopus-todo-bf7adc5203c3f43602429a6123fae597.png";